import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_API} from './_Action'
import {_PAGINATE} from './paginateAction'
import { TransactionCriteria } from 'src/type/criteria/transactionCriteria'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import { DocumentCriteria } from 'src/type/criteria/documentCriteria'

export const TRANSACTIONS_CHANGE = 'transactionsChange'
export const TRANSACTIONS_DETTE = 'transactionsDette'
export const TRANSACTIONS_PLACEMENT = 'transactionsPlacement'

const _TRANSACTIONS_CHANGE_PAGINATE = _PAGINATE(TRANSACTIONS_CHANGE)
const _TRANSACTIONS_DETTE_PAGINATE = _PAGINATE(TRANSACTIONS_DETTE)
const _TRANSACTIONS_PLACEMENT_PAGINATE = _PAGINATE(TRANSACTIONS_PLACEMENT)


export const fetchTransactionsChange = (c: TransactionCriteria) => (dispatch, getState: () => RootState) => {
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_TRANSACTIONS_CHANGE_PAGINATE.REQUEST, _TRANSACTIONS_CHANGE_PAGINATE.SUCCESS, _TRANSACTIONS_CHANGE_PAGINATE.FAILURE],
        route: route.transactions.fetchChange(enterpriseId, c)
      }
    })
}

export const fetchTransactionsDette = (c: TransactionCriteria) => (dispatch, getState: () => RootState) => {
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_TRANSACTIONS_DETTE_PAGINATE.REQUEST, _TRANSACTIONS_DETTE_PAGINATE.SUCCESS, _TRANSACTIONS_DETTE_PAGINATE.FAILURE],
        route: route.transactions.fetchDette(enterpriseId, c)
      }
    })
}

export const fetchTransactionsPlacement = (c: TransactionCriteria) => (dispatch, getState: () => RootState) => {
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_TRANSACTIONS_PLACEMENT_PAGINATE.REQUEST, _TRANSACTIONS_PLACEMENT_PAGINATE.SUCCESS, _TRANSACTIONS_PLACEMENT_PAGINATE.FAILURE],
        route: route.transactions.fetchPlacement(enterpriseId, c)
      }
    })
}

export const getDocumentRelateTransaction = (id: string) => (dispatch, getState: () => RootState) => {
  const actions = _API('get_document_relate_transaction')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.transactions.getDoc(enterpriseId, id)
    }
  })
}

export const fetchDocToSign = (c: SignatureCriteria) => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_docToSign')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.signature.searchDocToSign(enterpriseId, c)
    }
  })
}

export const fetchDocSigned = (c: SignatureCriteria) => (dispatch, getState: () => RootState) => {
    const actions = _API('PAGINATE_signatures')
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
        route: route.signature.searchDocSigned(enterpriseId, c)
      }
    })
}

export const fetchOtherDoc = (c: DocumentCriteria) => (dispatch, getState: () => RootState) => {
    const actions = _API('PAGINATE_docNotToSign')
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
        route: route.signature.searchDocNotToSign(enterpriseId, c)
      }
    })
}

export const getDocumentUrl = (id: string) => (dispatch, getState: () => RootState) => {
  const actions = _API('url_document')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.signature.getUrlDocument(enterpriseId, id)
    }
  })
}

export const getUrlSign = (enterpriseId: string, docId: string) => (dispatch, getState: () => RootState) => {
  const actions = _API('url_signatures')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.signature.getUrlToSign(enterpriseId, docId)
    }
  })
}



// WEBPACK FOOTER //
// ./src/core/redux/action/transactionsAction.ts